import React, {Component} from 'react'
import {observer} from 'mobx-react'

@observer export default class ErrorPageComponent extends Component {
    render() {

        return (
            <div>
                Произошла ошибка. Обратитесь к разработчику плагина.
            </div>
        )
    }
}